import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';

import ShowErrors from '../common/ShowErrors';
import { nl2br } from '../common/Utils';
import ReactPaginate from 'react-paginate';

import '../../react-paginate.css'
import '../../e-dist.css'
import PaginateTotal from '../common/PaginateTotal';
import moment from 'moment';

class CircularPagingTable extends Component {
    constructor(props) {
        super(props);
    }

    loadingMask() {
        return (
            <div>Loading...</div>
        );
    }

    showTable() {
        const { t, query, location, match, showCategory } = this.props;
        const { items, pageNo, pageSize, total } = query;

        let openAppendixUrl = window.location.pathname.replace('/gateway/','/api/');
        openAppendixUrl = openAppendixUrl + "openAppendix";

        const categoryHeader = [];
        if (showCategory) {
            categoryHeader.push(
                <th>
                    <a href="#" onClick={(e) => { this.props.handleSortingChange(e,'category'); }}>
                        {t('table.headers.category')}
                    </a>
                </th>
            );
        }
        
        return (
            <div className="table-container main-style circulars-table">
                <table>
                    <tbody>
                        <tr>
                            <th>
                                <a href="#" onClick={(e) => { this.props.handleSortingChange(e,'issueDate'); }}>
                                    {t('table.headers.issueDate')}
                                </a>
                            </th>
                            <th>
                                <a href="#" onClick={(e) => { this.props.handleSortingChange(e,'publication'); }}>
                                    {t('table.headers.publication')}
                                </a>
                            </th>
                            {categoryHeader}
                        </tr>
                    </tbody>
                    <tbody>
                    {items.map((circular) => {
                        let docUrl = circular.publicUrl;
                        let target = "_self";
                        if (match.params.urlPath !== undefined) {
                            var splitText = docUrl.split('/');
                            //docUrl = docUrl.replace(match.params.urlPath+'/','')
                            docUrl = splitText[splitText.length-1];
                        }

                        if(docUrl.includes("openFile")){
                            target = "_blank";
                        }

                        const categoryColumn = [];
                        if (showCategory) {
                            categoryColumn.push(
                                <td>
                                    {t('postDocType.' + circular.postDocType)}
                                </td>
                            );
                        }
                        return (
                            <tr key={circular.refNo}>
                                <td>
                                    {t('common:date.formatter',{date: moment(circular.releasedDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                                </td>
                                <td>
                                    <Link to={docUrl} target={target}>
                                        <div dangerouslySetInnerHTML={{__html:nl2br(circular.title)}}></div>
                                    </Link>
                                    <div className="mt-1 ml-2">
                                    {circular.appendixDocList.map((appendix) =>
                                    <Link key={appendix.refNo} to={`openAppendix?refNo=${circular.refNo}&appendix=${appendix.refNo}`} className="d-block" target="_blank">
                                        {appendix.caption}
                                    </Link>
                                    )}
                                    </div>
                                </td>
                                {categoryColumn}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
                <div className="pagination-toolbar">
                    <PaginateTotal pageNo={pageNo} pageSize={pageSize} total={total} />
                    <div className="pagination-toolbar pagebar">
                        <ReactPaginate
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel={'. . .'}                                        
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={7}
                            initialPage={pageNo}
                            disableInitialCallback={true}
                            pageCount={Math.ceil(total/pageSize)}
                            onPageChange={this.props.handlePageChange}
                            containerClassName={'pagination'}
                            previousClassName={'previous'}
                            breakClassName={'break'}
                            pageClassName={'page'}
                            activeClassName={'active'}
                            nextClassName={'next'}/>
                    </div>                        
                </div>
            </div>
        );
    }

    render() {        
        const { query } = this.props;

        if (query.isLoading) {
            return this.loadingMask();
        } else if (query.errors) {
            return (<ShowErrors errors={query.errors}/>);
        } else if (query.items) {
            return this.showTable();
        } else {
            return (
                <div>Initiating, please wait ...</div>
            );
        }
    }
}

export default withRouter(withTranslation()(CircularPagingTable));